// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__12zRq","sendOtp":"AuthorizeToLogin_sendOtp__38JKI"};